if ($('header')) {
    function slideCoundown(action) {
        const header = $($('header'))
        const headerTopbar = $('.header__topbar')
        const headerTopbarHeight = headerTopbar.outerHeight();
        if (action == 'open') {
            header.css('top', `0px`)
        }

        if (action == 'close') {
            header.css('top', `-${headerTopbarHeight}px`)
        }
    }

    var scrollPrev = 0;
    window.addEventListener("scroll", function () {
        let scrolled = document.documentElement.scrollTop;
        if (scrolled > 200 && scrolled > scrollPrev) {
            slideCoundown('close')
        } else if (scrolled < 200) {
            slideCoundown('open')
        }
        scrollPrev = scrolled;
    });


    const menuItems = $('.menu-item-has-children')
    menuItems.on('click', function (e) {
        const $this = $(this);
        if ($(e.target).hasClass('menu-item-has-children')) {
            const subMenu = $this.find('.sub-menu')
            subMenu.slideToggle();
            $this.toggleClass("item__active");
        }
    })

    addEventListener("resize", () => {
        if (!window.matchMedia("(max-width: 992px)").matches) {
            if ($('.navbar-collapse.collapse').hasClass('in')) {
                $('.navbar-toggle').click()
            }
        }
    });
}